export enum GuestType {
  MAIN_GUEST = "mainGuest",
  COMPANION = "companion",
}
